"use client";

import type { VideoDubbingDemoProps } from "./VideoDubbingDemo";

import dynamic from "next/dynamic";

const VideoDubbingDemoLazy = dynamic<VideoDubbingDemoProps>(() =>
  import("./VideoDubbingDemo").then(mod => mod.VideoDubbingDemo),
);

export default VideoDubbingDemoLazy;
